
 export const ERROR_COLOR = '#f44336'
 export const SECONDARY_COLOR = 'rgb(92 109 126)'
 export const MAIN_COLOR = '#1976d2'
 export const SUCCESS_COLOR = '#87b757'